export enum DrupalMenuMachineName {
	Main = 'main',
}
